package structs.accelbyte.promo

import kotlinx.serialization.Serializable
import structs.accelbyte.common.AccelByteJson
import structs.accelbyte.common.AccelByteSerializable

/**
 * Player-facing request to redeem a single promo code.
 *
 * `userId` is intentionally absent from this wire shape: the proxy pins the
 * actor from `RpcCallContext.userId` so a malicious caller cannot redeem on
 * behalf of another user. Mirrors `MapStorageProxy`'s ownership-pin pattern
 * in the same module.
 *
 * @property codeValue The literal code the player typed. Whitespace is
 *   trimmed by the proxy before AGS calls.
 */
@Serializable
data class RedeemPromoCodeRequest(
    val codeValue: String
) : AccelByteSerializable {
    override fun toJsonString(): String = AccelByteJson.encodeToString(serializer(), this)
}
